var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlusOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.7,
    height: 24.699,
    viewBox: "0 0 24.7 24.699",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_20",
    "data-name": "Union 20",
    d: "M12859.669,20110.352a12.35,12.35,0,1,1,12.353,12.348A12.364,12.364,0,0,1,12859.669,20110.352Zm1.545,0a10.8,10.8,0,1,0,10.808-10.807A10.816,10.816,0,0,0,12861.214,20110.352Zm10.035,5.4v-4.631h-4.631a.771.771,0,1,1,0-1.541h4.631v-4.635a.772.772,0,0,1,1.545,0v4.635h4.626a.771.771,0,1,1,0,1.541h-4.626v4.631a.772.772,0,1,1-1.545,0Z",
    transform: "translate(-12859.669 -20098)",
    fill: "#d9d9d9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusOff);
export default __webpack_public_path__ + "static/media/plus-off.9ba847835704c744b7959644013ac130.svg";
export { ForwardRef as ReactComponent };